import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CustomDialog from '../CustomDialog/CustomDialog';
import Button from '../Common/Button';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

export default function CustomInfoPopup(props) {
  //   const { t } = useTranslation();
  const { open, text, buttonLabel, onClick } = props;
  const [isDesktop] = useCheckScreenSize();

  const useStyles = makeStyles({
    dialogBody: {
      padding: '30px 0px 49px',
      textAlign: 'center',
      maxWidth: isDesktop ? 300 : 200,
    },
    dialogBodyText: {
      textAlign: 'center',
      fontSize: '16px',
    },
    dialogButton: { fontSize: '14px', marginTop: '8px' },
  });
  const classes = useStyles();

  return (
    <CustomDialog
      noBorder
      backgroundColor={'linear-gradient(to bottom, #194378, #30eaff)'}
      open={open}
      style={{
        paddingLeft: isDesktop ? 240 : 0,
        marginTop: isDesktop ? 0 : 40,
        marginBottom: isDesktop ? 0 : 80,
      }}
    >
      <Box className={classes.dialogBody}>
        <Typography variant="body2" className={classes.dialogBodyText}>
          {text}
        </Typography>
        {onClick && (
          <Box mt={3}>
            <Button
              className={classes.dialogButton}
              variant="outlined"
              outlinedColor="white"
              width="194px"
              onClick={onClick}
            >
              {/* Add lokalise*/}
              {buttonLabel ? buttonLabel : 'OK'}
            </Button>
          </Box>
        )}
      </Box>
    </CustomDialog>
  );
}

CustomInfoPopup.propTypes = {
  /* Dialog opened */
  open: PropTypes.bool,
  /* Popup text being displayed */
  text: PropTypes.string,
  /* Function called when list item is clicked. */
  onClick: PropTypes.func,
  /* Button label */
  buttonLabel: PropTypes.string,
};
